import type { ScaleTime, ScaleLinear } from 'd3-scale';
import { NarrativeMarker } from './Marker';
import { ChartVisualization } from './ChartVisualization';
import type { ChartDimensions } from '../types';
import type {
  NormalisedDataPoint,
  NormalisedValuation,
} from '../utils/normaliseChartData';
import { Chart } from './MiniPriceChart/styled';
import type { Period } from '@/utilities/timeSeriesPeriodMap';

interface ChartContentProps {
  height: number;
  keys: number[];
  normalisedEntities: Record<number, NormalisedDataPoint>;
  normalisedValuations?: NormalisedValuation[];
  periods: Record<Period | 'NOW', number>;
  period: Period;
  positionX: number;
  xScale: ScaleTime<number, number>;
  yScale: ScaleLinear<number, number>;
  dimensions: ChartDimensions;
  interactive: boolean;
  onHover?: (param: {
    time: number;
    value: number | null;
    fairValue: number | null;
  }) => void;
  fillColor: string;
  strokeColor: string;
}

export const ChartContent = ({
  height,
  keys,
  normalisedEntities,
  normalisedValuations,
  periods,
  period,
  positionX,
  xScale,
  yScale,
  dimensions,
  interactive,
  onHover,
  fillColor,
  strokeColor,
}: ChartContentProps) => {
  return (
    <>
      {interactive && (
        <NarrativeMarker
          height={height}
          keys={keys}
          entities={normalisedEntities}
          periods={periods}
          period={period}
          positionX={positionX}
          xScale={xScale}
          yScale={yScale}
          valuations={normalisedValuations}
          onHover={onHover}
          priceFillColor={strokeColor}
        />
      )}

      <Chart
        y="0"
        x="0"
        width={dimensions.width}
        height={height}
        transform={`translate(${positionX}, 0)`}
        role="img"
        aria-label="Mini price chart"
      >
        <ChartVisualization
          keys={keys}
          normalisedEntities={normalisedEntities}
          xScale={xScale}
          yScale={yScale}
          dimensions={dimensions}
          fillColor={fillColor}
          strokeColor={strokeColor}
        />
      </Chart>
    </>
  );
};
